import { DatePresetRange } from './types';
import {
  endOfMonth,
  endOfWeek,
  endOfYear,
  startOfMonth,
  startOfToday,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
  subWeeks,
} from 'date-fns';

export const getDateByPreset = (datePreset: DatePresetRange) => {
  const now = new Date();
  let start: Date, end: Date;

  switch (datePreset) {
    case 'today':
      start = end = startOfToday();
      break;
    case 'yesterday':
      start = end = subDays(startOfToday(), 1);
      break;
    case 'current_week':
      start = startOfWeek(now, { weekStartsOn: 1 });
      end = endOfWeek(now, { weekStartsOn: 1 });
      break;
    case 'last_week':
      start = startOfWeek(subWeeks(now, 1), { weekStartsOn: 1 });
      end = endOfWeek(subWeeks(now, 1), { weekStartsOn: 1 });
      break;
    case 'current_month':
      start = startOfMonth(now);
      end = endOfMonth(now);
      break;
    case 'last_month':
      start = startOfMonth(subMonths(now, 1));
      end = endOfMonth(subMonths(now, 1));
      break;
    case 'current_year':
      start = startOfYear(now);
      end = endOfYear(now);
      break;
    case 'last_year':
      start = startOfYear(subDays(now, 365));
      end = endOfYear(subDays(now, 365));
      break;
    case 'all_time':
      start = new Date(0);
      end = now;
      break;
  }

  return { start, end };
};
